import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

// Botón "Descargar app": aparece si la app aún no está instalada (PC o celular) y se quita al instalarla.
export default function InstallAppButton() {
  const [prompt, setPrompt] = useState(() => window.__zvPrompt || null);
  const [installed, setInstalled] = useState(isStandalone());
  const [iosHelp, setIosHelp] = useState(false);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("zv_install_hide") === "1");

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed || hidden || window.location.pathname.startsWith("/kiosk")) return null;
  const ios = isIOS();
  if (!prompt && !ios) return null;

  const install = async () => {
    if (ios) { setIosHelp(true); return; }
    prompt.prompt();
    const r = await prompt.userChoice.catch(() => null);
    if (r?.outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };
  const close = () => { sessionStorage.setItem("zv_install_hide", "1"); setHidden(true); };

  return (
    <div className="fixed left-4 bottom-28 md:bottom-4 z-[72] flex flex-col items-start gap-2" data-testid="install-app">
      {iosHelp && (
        <div className="max-w-[280px] bg-white text-navy text-xs rounded-xl shadow-2xl border border-nardo-200 p-3" data-testid="install-ios-help">
          En iPhone: toca <Share className="inline w-3.5 h-3.5 -mt-0.5" /> <b>Compartir</b> abajo en Safari y luego <b>“Agregar a inicio”</b>.
        </div>
      )}
      <div className="flex items-center gap-1 bg-navy text-white rounded-full shadow-2xl shadow-navy/40 pl-4 pr-1.5 py-1.5">
        <button onClick={install} data-testid="install-app-btn" className="inline-flex items-center gap-2 text-sm font-semibold">
          <Download className="w-4 h-4" /> Descargar app
        </button>
        <button onClick={close} data-testid="install-app-close" title="Ahora no" className="p-1.5 rounded-full hover:bg-white/15"><X className="w-3.5 h-3.5" /></button>
      </div>
    </div>
  );
}
